<icc-list [items]="shapes" (select)="selectShape($event)"  [itemTemplate]="itemShape" itemWidth="narrow" itemImgHeight="medium" [selected]="selectedId"></icc-list>


<ng-template #itemShape let-item="iccListItem">
    <div class="item-shape">
        <icc-dimensions-legend [shape]="item.shape" [variant]="item.variant" [highlight]="null" [fieldPrefix]="true"></icc-dimensions-legend>
    </div>
</ng-template>
